export const MIME_TYPES = {
    PDF: 'application/pdf',
    JPEG: 'image/jpeg',
    PNG: 'image/png'
};

export const isInternalFile = (linkedFile) => {
    return linkedFile?.fullpath == null;
};

export const getAssetFromLinkedFilesAndGuidances = (assets = [], guidances = [], linkedFiles = []) => {
    const guidance = guidances?.[0];
    const linkedFile = linkedFiles?.[0];
    let id;

    if (guidance?.dataProviderAssignedUniqueId) {
        id = guidance.dataProviderAssignedUniqueId;
    }

    if (linkedFile?.dataProviderAssignedUniqueId) {
        id = linkedFile.dataProviderAssignedUniqueId;
    }

    if (!id) {
        return {};
    }

    const asset = assets.find(item => item.dataproviderassigneduniqueid === id);

    if (!asset) {
        return {};
    }

    const feature = asset?.feature;
    const featureId = feature?.getId?.();
    const featureProps = feature?.getProperties?.();

    if (!featureId || !featureProps?.dataproviderassigneduniqueid) {
        return {};
    }

    const assetType = featureId.split('.')[0];
    const assetTypeId = featureProps.dataproviderassigneduniqueid;

    return {
        asset,
        assetType,
        assetTypeId
    };
};

export const sortGuidancesByDescriptionLength = (guidances = []) => {
    return [...guidances].sort((a, b) => {
        const aLen = a?.description?.length || 0;
        const bLen = b?.description?.length || 0;
        return bLen - aLen;
    });
};
